/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _default = function _default(defaultSize) {
  var size;
  var setSize;
  var _useState = (0, _react.useState)(defaultSize);
  var _useState2 = (0, _slicedToArray2.default)(_useState, 2);
  size = _useState2[0];
  setSize = _useState2[1];
  return [size, function (newSize) {
    setSize({
      width: Math.round(newSize.width || size.width || 0),
      height: Math.round(newSize.height || size.height || 0)
    });
  }];
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/hooks/useSize.js
// module id = 611
// module chunks = 0